export class AvailableTime {
    time: string;

    public static Make(data: unknown): AvailableTime {
        const availableTime: AvailableTime = {
            time: (data as any).time || '',
        };

        return availableTime;
    }
}

export class AvailableTimesResponse {
    times: AvailableTime[];

    public static Make(data: unknown): AvailableTimesResponse {
        const availableTimesResponse: AvailableTimesResponse = {
            times: ((data as any).times || []).map((time: unknown) => AvailableTime.Make(time)),
        };

        return availableTimesResponse;
    }
}
